(() => {
  'use strict';
  const titleSelector = 'h1,h2,h3,h4,h5,h6,.h1,.h2,.h3,.h4,.h5,.h6,.grid-product__title,.cmb-card-title,.collection-item__title,.cart__item-name,.mbo-breadcrumb,.mbo-option--material .mbo-pill-text,.mbo-option--material .mbo-option-label,[data-mbo-title-case]';
  const keep = new Set(['MBO','PET','UV','UPF','PVP','SKU','S','M','L','XL','XXL','XXXL','FAQ','DNI','RUC']);
  function titleCase(text) {
    return text.replace(/[\p{L}\p{N}]+/gu, word => {
      const upper = word.toLocaleUpperCase('es');
      if (keep.has(upper) || /^(PV|OI)\d+$/i.test(word) || (/\d/.test(word) && /\p{L}/u.test(word))) return word.toUpperCase();
      const lower = word.toLocaleLowerCase('es');
      return lower.charAt(0).toLocaleUpperCase('es') + lower.slice(1);
    });
  }
  function normalize(root) {
    if (!(root instanceof Element) || root.closest('script,style,textarea,input,select,[contenteditable="true"],[data-mbo-preserve-case]')) return;
    const elements = [...root.querySelectorAll(titleSelector)];
    if (root.matches(titleSelector)) elements.unshift(root);
    elements.forEach(element => {
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.parentElement.closest('script,style,textarea,select,svg,[data-mbo-preserve-case]')) continue;
        if (!node.nodeValue.trim()) continue;
        node.parentElement.style.setProperty('text-transform', 'none', 'important');
        const next = titleCase(node.nodeValue);
        if (next !== node.nodeValue) node.nodeValue = next;
      }
    });
  }
  function initTitles() {
    normalize(document.body);
    new MutationObserver(records => {
      const roots = new Set();
      records.forEach(record => {
        if (record.type === 'characterData') {
          const parent = record.target.parentElement?.closest(titleSelector);
          if (parent) roots.add(parent);
        } else record.addedNodes.forEach(node => {
          if (node instanceof Element) roots.add(node);
          else if (node.parentElement?.closest(titleSelector)) roots.add(node.parentElement.closest(titleSelector));
        });
      });
      roots.forEach(normalize);
    }).observe(document.body, {subtree: true, childList: true, characterData: true});
  }
  document.addEventListener('DOMContentLoaded', initTitles, {once: true});

  if (!customElements.get('mbo-complementary')) {
    customElements.define('mbo-complementary', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded || !this.dataset.url) return;
        this.dataset.loaded = 'true';
        fetch(this.dataset.url, {credentials: 'same-origin'})
          .then(response => { if (!response.ok) throw new Error('Recommendations unavailable'); return response.text(); })
          .then(html => {
            if (!this.isConnected) return;
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const source = doc.getElementById(this.id);
            if (source?.querySelector('.mbo-complementary-link')) {
              this.innerHTML = source.innerHTML;
              this.hidden = false;
              normalize(this);
            }
          }).catch(() => { /* Empty or unavailable recommendations never block purchase. */ });
      }
    });
  }
})();
